<template>
  <div>
    <div class='h-olap-search-area'>
      <ejs-textbox :placeholder='searchHolder' v-model='keywords'></ejs-textbox>
      <ejs-button :isPrimary='true' @click.native='queryByNum' cssClass='olap-search-button'>{{$t('TS.ts_search')}}</ejs-button>
    </div>
    <div class='h100-47 h-scroll'>
      <ejs-grid ref='grid' height='calc(100vh - 520px)' :dataSource='data' :allowSorting='true' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column field='terminalId' minWidth='10' :headerText='$t("TS.numHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='terminalType' minWidth='10' :headerText='$t("TS.terminalTypeHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='terminalTypeFormat'></e-column>
          <e-column field='registerStatus' minWidth='10' :headerText='$t("TS.registerStatusHeader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='registerStatusFormat'></e-column>
          <e-column field='unreg' minWidth='10' :headerText='$t("TS.unReg")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='unregFormat'></e-column>
          <e-column field='registerTime' minWidth='10' :headerText='$t("TS.registerTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='dateTime' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <e-column field='registerAddress' minWidth='10' :headerText='$t("TS.registerAddress")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='registerAddressFormat'></e-column>
          <e-column field='operateResult' minWidth='10' :headerText='$t("TS.operateResult")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='operateResultFormat'></e-column>
          <e-column field='failCause' minWidth='10' :headerText='$t("TS.ts_register_callCause")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getListData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../plugins/eventBus';
import Global from '../Global';
import CustomDialog from '../../common/CustomDialog';
import { Reorder, Resize, Sort } from '@syncfusion/ej2-vue-grids';
export default {
  name: 'RegisterDetailGrid',
  data() {
    return {
      olapUrl: Global.olapUrl,
      searchHolder: this.$t('TS.searchByNumHolder'),
      keywords: '',
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      queryConditions: {},
      data: [],
    };
  },
  provide: {
    grid: [Reorder, Resize, Sort]
  },
  methods: {
    terminalTypeFormat(grid, data) {
      if (data.terminalType !== null && data.terminalType !== '') {
        return this.$t(`TS.terminalType_${data.terminalType}`);
      } else {
        return '';
      }
    },
    registerStatusFormat(grid, data) {
      if (data.registerStatus !== null && data.registerStatus !== '') {
        return this.$t(`TS.registerStatus_${data.registerStatus}`);
      } else {
        return '';
      }

    },
    unregFormat(grid, data) {
      if (data.unreg !== null && data.unreg !== '') {
        return this.$t(`TS.unReg_${data.unreg}`);
      } else {
        return '';
      }
    },
    registerAddressFormat(grid, data) {
      if (data.registerAddress !== null && data.registerAddress !== '') {
        let ip = "";
        let number = data.registerAddress;
        if(number <= 0) {
          return ip;
        }
        const ip3 = (number << 0 ) >>> 24;
        const ip2 = (number << 8 ) >>> 24;
        const ip1 = (number << 16) >>> 24;
        const ip0 = (number << 24) >>> 24
        ip += ip3 + "." + ip2 + "." + ip1 + "." + ip0;
        return ip;
      } else {
        return '';
      }
    },
    operateResultFormat(grid, data) {
      if (data.operateResult !== null && data.operateResult !== '') {
        return this.$t(`TS.operateResult_${data.operateResult}`);
      } else {
        return '';
      }
    },
    queryByNum(){
      this.getListData();
    },
    setQueryParams(params) {
      this.page.pageSize = 10;
      this.queryConditions = params;
      this.keywords = '';
      this.getListData();
    },
    getListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = This.getParams();
      params.pageNo = parseInt(This.page.pageNo, 10);
      params.pageSize =  parseInt(This.page.pageSize, 10);
      params.num = This.keywords;
      params.isCaller = 1;
      This.$loading.showLoadding(this.$t('MML.loadingTip'));
      This.$axios.post(`${This.olapUrl}/lte/ems/olap/register/detailStatistics`, params).then((response) => {
        if (response && response.status === 200) {
          const result = response.data;
          This.page.totalCount = result.total;
          This.data = result.list;
        } else {
          EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
        }
        This.$loading.hideLoadding();
      }).catch(err => {
        This.$loading.hideLoadding();
      });
    },
    getParams() {
      const {timeInterval,startdate,enddate,neId,xAxisValue,detailType} = this.queryConditions;
      const [beginHourAndMin,endHourAndMin] = xAxisValue.split('~');
      let startDate = `${startdate}`;
      let endDate = `${enddate}`;
      // 如果是天 需要手动赋00:00 xAxisValue表示的是天和时
      if (timeInterval === 2){
        const year = startdate.split('-')[0];
        startDate = `${year}-${beginHourAndMin} 00:00:00`;
        endDate = `${year}-${beginHourAndMin} 23:59:59`;
      } else {
        startDate = `${startDate} ${beginHourAndMin}:00`;
        if(("23:45" === beginHourAndMin || "23:00" === beginHourAndMin) && "00:00" === endHourAndMin){
          endDate = `${endDate} 23:59:59`;
        } else {
          endDate = `${endDate} ${endHourAndMin}:00`;
        }
      }
      const beginTime = new Date(startDate);
      const endTime = new Date(endDate);
      return {beginTime,endTime,neId,detailType}
    }
  }
};
</script>

<style scoped>


  .h-olap-search-area{
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 15px
  }
  .olap-search-button{
    margin-left:10px
  }
</style>
